class ProjectContent {
    constructor(projectContentEl) {
        this.projectContentEl = projectContentEl;
        this.linkBackEl = this.projectContentEl.querySelector('.link-back a')
        this.linkBackURL = this.linkBackEl.dataset.url

        this.initEventListeners()
    }

    initEventListeners() {
        this.linkBackEl.addEventListener('click', () => this.handleBackToOverviewClick())
    }

    handleBackToOverviewClick() {
        const ref = document.referrer;

        if (ref && ref.includes(this.linkBackURL)) {
            window.history.back();
        } else {
            window.location.href = this.linkBackURL
        }
    }
}

export default function initProjectContent() {
    const projectContentEl = document.querySelector('.projectHead')
    if (!projectContentEl) return

    new ProjectContent(projectContentEl)
}
